/* sp-card-slider.js — scroll-snap tabanlı kart kaydırıcı (ok/nokta/sürükleme) + görünüme girince belirme.
   Sabit metin yok; etiketler Liquid'den aria-label ile gelir. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Slider(root) {
    this.root = root;
    this.track = root.querySelector('[data-sp-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-sp-slide]'));
    this.prev = root.querySelector('[data-sp-prev]');
    this.next = root.querySelector('[data-sp-next]');
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-sp-dot]'));
    this.index = 0;
    this.pages = 1;
  }
  Slider.prototype.init = function () {
    if (!this.track || !this.slides.length) return;
    var self = this;
    if (this.prev) this.prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.goTo(self.index + 1); });
    this.dots.forEach(function (d) {
      d.addEventListener('click', function () { self.goTo(parseInt(d.getAttribute('data-sp-dot'), 10) || 0); });
    });
    var t;
    this.track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { self.syncFromScroll(); }, 80);
    }, { passive: true });
    var r;
    window.addEventListener('resize', function () {
      clearTimeout(r);
      r = setTimeout(function () { self.update(); }, 120);
    });
    this.update();
  };
  Slider.prototype.perPage = function () {
    var w = this.track.clientWidth, s = this.slides[0];
    if (!s) return 1;
    var sw = s.getBoundingClientRect().width;
    var step = this.slides.length > 1 ? this.slides[1].offsetLeft - s.offsetLeft : sw;
    if (sw <= 0 || step <= 0) return 1;
    return Math.max(1, Math.floor((w + (step - sw) + 1) / step));
  };
  Slider.prototype.update = function () {
    this.pages = Math.max(1, this.slides.length - this.perPage() + 1);
    this.root.classList.toggle('is-single', this.pages <= 1);
    var self = this;
    this.dots.forEach(function (d, k) {
      var li = d.parentElement;
      if (li) li.classList.toggle('is-hidden', k >= self.pages);
    });
    this.setActive(Math.min(this.index, this.pages - 1));
  };
  Slider.prototype.goTo = function (i) {
    i = Math.max(0, Math.min(this.pages - 1, i));
    var s = this.slides[i];
    if (!s) return;
    this.track.scrollTo({ left: s.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    this.setActive(i);
  };
  Slider.prototype.syncFromScroll = function () {
    var x = this.track.scrollLeft, best = 0, bd = Infinity;
    this.slides.forEach(function (s, k) {
      var d = Math.abs(s.offsetLeft - x);
      if (d < bd) { bd = d; best = k; }
    });
    this.setActive(Math.min(best, this.pages - 1));
  };
  Slider.prototype.setActive = function (i) {
    this.index = i;
    this.dots.forEach(function (d, k) {
      d.classList.toggle('is-active', k === i);
      d.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    if (this.prev) this.prev.disabled = i <= 0;
    if (this.next) this.next.disabled = i >= this.pages - 1;
  };

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('[data-sp-slider]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.spSliderReady) return;
      el.dataset.spSliderReady = '1';
      new Slider(el).init();
    });
  }

  /* Görünüme girince belirme (ölçüm: rootMargin alt −50px, tek sefer) */
  function reveal() {
    var els = document.querySelectorAll('[data-sp-reveal]:not(.sp-cs--reveal)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sp-cs--shown'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -50px 0px' });
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight - 50 && r.bottom > 0) return; /* zaten görünürse gizleme */
      el.classList.add('sp-cs--reveal');
      io.observe(el);
    });
  }

  function boot() { initAll(document); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); reveal(); });
})();
